<template>
  <transition name="notice">
    <div v-if="visible" :class="'notice notice-'+type">
      <div class="notice-heading">
        <span class="notice-icon notice-icon-spinning" v-if="isProgress">
          <span class="notice-spinner"></span>
        </span>
        <span class="notice-icon" v-else v-html="getSVG(getNoticeIcon)" />
        <span>{{ heading }}</span>
        <span class="notice-close" v-if="!isProgress" @click="closeArea" v-html="getSVG('times')" />
      </div>
      <div class="notice-content">
        <div class="notice-text">{{ content }}</div>
        <div class="notice-progress-step" v-if="progressStep">{{ progressStep }}</div>
        <button v-if="buttonText&&buttonText!==''"
                :class="'button button-notice button-secondary button-notice-'+type"
                @click="buttonAction"
        >{{ buttonText }}</button>
      </div>
    </div>
  </transition>
</template>

<style>
.notice {
  position: fixed;
  right: 30px;
  top: 130px;
  width: 350px;
  overflow: hidden;
  z-index: 5000;
  background-color: var(--son-hellgrau);
}

.notice-heading {
  color: white;
  padding: 15px 45px;
  font-weight: bold;
  position: relative;
  background-color: var(--son-dunkelgrau);
}

.notice-icon svg {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.notice-close {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.notice-close svg {
  width: 15px;
  height: 15px;
  display: block;
}

.notice-content {
  padding: 15px;
}

.notice-success .notice-heading {
  background-color: var(--success);
}

.notice-warning .notice-heading {
  background-color: var(--warning);
}

.notice-error .notice-heading {
  background-color: var(--error);
}

.notice-info .notice-heading {
  background-color: var(--info);
}

.notice-progress .notice-heading {
  background-color: var(--info, #2196f3);
}

.notice-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: notice-spin 0.8s linear infinite;
}

.notice-icon-spinning {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

@keyframes notice-spin {
  to { transform: rotate(360deg); }
}

.notice-progress-step {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 13px;
  color: #666;
  font-style: italic;
}

.notice-enter-active,
.notice-leave-active {
  transition: transform .3s;
}

.notice-enter-from,
.notice-leave-to {
  transform: translateX(calc(100% + 30px));
}

.notice-enter-to,
.notice-leave-from {
  transform: translateX(0);
}
</style>

<script>
export default {
  data() {
    return {
      timeout: null,
    }
  },
  props: [
    "model",
  ],
  watch: {
    model(val, ignored_oldVal) {
      if(this.timeout !== null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      // Sticky/Progress-Notices verschwinden NICHT automatisch
      // (z.B. fuer Upload-Verarbeitung mit Phasen-Anzeige)
      if(val.visible && !val.sticky && val.type !== 'progress') {
        this.timeout = setTimeout(() => {
          this.closeArea();
          this.timeout = null;
        }, 5000);
      }
    }
  },
  computed: {
    cleanedModel() {
      if(typeof this.model === "object" && this.model !== null) {
        return this.model;
      } else {
        return {};
      }
    },
    type() {
      switch(this.cleanedModel.type) {
        case "success":
          return "success";
        case "warning":
          return "warning";
        case "error":
          return "error";
        case "progress":
          return "progress";
        case "info":
        default:
          return "info";
      }
    },
    isProgress() {
      return this.cleanedModel.type === 'progress';
    },
    progressStep() {
      return this.cleanedModel.progressStep || '';
    },
    heading() {
      if(this.cleanedModel.heading) {
        return this.cleanedModel.heading;
      }
      switch(this.type) {
        case "info":
          return "Information";
        case "success":
          return "Abgeschlossen";
        case "warning":
          return "Achtung";
        case "error":
          return "Kritischer Fehler";
        case "progress":
          return "Verarbeitung läuft";
      }
    },
    content() {
      if(this.cleanedModel.content) {
        return this.cleanedModel.content;
      }
      return '';
    },
    visible() {
      return this.cleanedModel.visible === true;
    },
    buttonText() {
      if(this.cleanedModel.buttonText) {
        return this.cleanedModel.buttonText;
      }
      return '';
    },
    buttonAction() {
      if(typeof this.cleanedModel.buttonAction === "function") {
        return this.cleanedModel.buttonAction;
      }
      return () => {
      };
    },
    getNoticeIcon() {
      switch(this.type) {
        case "info":
          return "info";
        case "success":
          return "success";
        case "warning":
        case "error":
          return "warning";
      }
    }
  },
  methods: {
    closeArea() {
      this.model.visible = false;
      if(this.timeout !== null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }
}
</script>